import { useMemo } from 'react';
import * as dates from '@simplybenefits/sb-dates';
import { constants } from '@simplybenefits/sb-utils';
import determineBenefitStatus from './determineBenefitStatus.js';

const BENEFIT_NAME_MAP = constants.BENEFIT_NAME_MAP;

/**
 * 
 * @param {*} benefitData 
 * @param {*} benefitName 
 * @param {*} userMeta 
 * @param {*} asoType
 * @returns 
 */
export const useBenefitTile = (benefitData, benefitName, userMeta, asoType) => useMemo(() => {
    const statusData = determineBenefitStatus(benefitData, benefitName, userMeta);
    const { status, color } = statusData;

    const hasCoverage = status !== "No Coverage";
    const isBenefitActiveOrEligible = [ 'Active', 'Not Eligible' ].includes(status);
    const canToggle = [ 'Active', 'Not Eligible', 'Terminated' ].includes(status);

    // Spending accounts and ASO In Arrears are exempt from standard premium waiver
    const isSpendingAccounts = benefitName === 'spendingAccounts';
    const isAsoInArrears = asoType !== null && asoType.toLowerCase() === 'arrears';

    const isAsoDental = benefitName === 'dental' 
        && userMeta.isAsoDental
        && isAsoInArrears;

    const isAsoHealth = [ 'majorMedical', 'vision', 'paramedicals', 'drugs' ]
        .includes(benefitName) 
        && userMeta.isAsoHealth
        && isAsoInArrears;

    const isBenefitPremiumWaived = benefitData.isPremiumWaived === 1 && Boolean(benefitData.premiumWaivedEffectiveDate);
        
    const isBenefitPremiumEligibleForWaiver =
            !isSpendingAccounts && 
            isBenefitActiveOrEligible && 
            !isAsoDental && 
            !isAsoHealth;

    const showMenu = canToggle || isBenefitPremiumEligibleForWaiver;

    return {
        title: BENEFIT_NAME_MAP[benefitName],
        status,
        statusColor: color,
        hasCoverage,
        showMenu,
        canToggle,
        canWaive: isBenefitPremiumEligibleForWaiver,
        carrier: benefitData.carrier,
        displayDates: {
            effective: dates.getStartOfDay(benefitData.eligibilityPeriodEnds, 'll'),
            waived: isBenefitPremiumWaived ? dates.getStartOfDay(benefitData.premiumWaivedEffectiveDate, 'll') : null,
            termination: status === 'Terminated' ? dates.formatDateForDisplay(benefitData.eligibilityTermDate) : null
        },
        actions: {
            toggle: {
                type: isBenefitActiveOrEligible ? "TERMINATE_BENEFIT" : "REINSTATE_BENEFIT",
                label: isBenefitActiveOrEligible ? 'Terminate Benefit' : 'Reinstate Benefit'
            },
            waiver: {
                type: isBenefitPremiumWaived ? 'REINSTATE_PREMIUM' : 'WAIVE_PREMIUM',
                label: isBenefitPremiumWaived ? "Reinstate Premium" : "Waive Premium"
            }
        }
    };
}, [ benefitData, benefitName, userMeta ]);